import React from 'react';

import EkovillaProvider from './providers/EkovillaProvider';

import EkovillaTable from './components/EkovillaTable';
import EkovillaTotal from './components/EkovillaTotal';
import CompetitorTable from './components/CompetitorTable';
import CompetitorTotal from './components/CompetitorTotal';
import TextBox from './components/TextBox';

function App() {
  return (
    <EkovillaProvider>
      <div className="App-top">
        <div className="container mx-auto">
          <div className="flex flex-wrap">
            <div className="w-full sm:w-2/3">
              <img className="pl-2 pr-2 sm:pl-6" src="images/ekovilla_counter_logo.jpg" alt="counter logo"></img>
            </div>
            <div className="w-1/3">
              <img className="sm:pt-16 lg:pt-24 pl-8 pb-4 bottom-0 right-0" src="images/ekovilla_logo.png" alt="ekovilla logo"></img>
            </div>
          </div>
          <div className="bg-white rounded-t-3xl md:p-4">
            <div className="flex flex-wrap">
              <div className="w-full xl:w-2/3 p-4 lg:p-8">
                <EkovillaTable />
                <EkovillaTotal />
              </div>
              <div className="w-full hidden xl:inline xl:w-1/3 xl:p-8">
                <TextBox />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="App-bottom">
        <div className="container mx-auto border-dashed border-t-2 border-gray-500">
          <div className="bg-white rounded-b-3xl md:p-4">
            <div className="flex flex-wrap">
              <div className="w-full p-4 lg:p-8">
                <CompetitorTable />
              </div>
              <div className="w-full xl:w-2/3 p-4 lg:p-8">
                <CompetitorTotal />
              </div>
              <div className="flex justify-center w-full xl:w-1/3 p-8">
                <img className="xl:pl-40 xl:pt-6" src="images/ekovilla40v_logo.png" alt="ekovilla 40v logo"></img>
              </div>
            </div>
          </div>
        </div>
        <div className="p-8 lg:p-16">
        </div>
      </div>
    </EkovillaProvider>
  );
}

export default App;
